import { render, staticRenderFns } from "./IconArrowRightLarge.vue?vue&type=template&id=5c28c762&scoped=true&"
import script from "./IconArrowRightLarge.vue?vue&type=script&lang=js&"
export * from "./IconArrowRightLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28c762",
  null
  
)

export default component.exports